export const headCellCashCardProduct = [
  { id: "", disablePadding: false, label: "" },
  { id: "id", disablePadding: false, label: "Id" },
  { id: "name", disablePadding: false, label: "Compañia" },
  { id: "barCode", disablePadding: false, label: "Código de barras" },
  { id: "amount", disablePadding: false, label: "Monto" },
  { id: "createdAt", disablePadding: false, label: "Agregado el" },
  { id: "site", disablePadding: false, label: "Sucursal" },
];
